import {
  Chip,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import React, { useState } from 'react';
import type { ModerationAction, ReportDTO } from './models/moderation';
import { FilterCheckOutputCategory } from './models/moderation';
import { capitalizeFirstLetter } from './utils';

export function CategoryManager(props: {
  setCategories: any;
  categories: any;
  report: ReportDTO;
  onAddAction: (
    reportID: string,
    action: Omit<ModerationAction, 'createdAt' | 'moderatorId'>
  ) => void;
}) {
  const { report } = props;
  const [categories, setCategories] = useState<Array<any>>(props.categories);

  React.useEffect(() => {
    setCategories(props.categories);
  }, [props]);

  const handleDelete = (category: FilterCheckOutputCategory) => {
    const newCategories = categories.filter(c => c !== category);
    setCategories(newCategories);
    props.setCategories(newCategories);
  };
  const handleAdd = async (newCategory: FilterCheckOutputCategory) => {
    const newCategories = categories.concat([newCategory]);
    setCategories(newCategories);
    props.setCategories(newCategories);
  };

  const addableCategories: FilterCheckOutputCategory[] = [
    FilterCheckOutputCategory.OBSCENITY,
    FilterCheckOutputCategory.SUICIDAL_IDEATION,
    FilterCheckOutputCategory.TRIGGERING,
    FilterCheckOutputCategory.HATE,
    FilterCheckOutputCategory.SELF_HARM,
    FilterCheckOutputCategory.SEXUAL,
    FilterCheckOutputCategory.SEXUAL_MINORS,
    FilterCheckOutputCategory.VIOLENCE,
    FilterCheckOutputCategory.SPAMMY,
    FilterCheckOutputCategory.BULLYING,
    FilterCheckOutputCategory.MISINFORMATION,
    FilterCheckOutputCategory.TROLLING,
    FilterCheckOutputCategory.ASKS_OR_PROVIDES_PERSONAL_INFORMATION,
  ];

  const availableCategories = addableCategories.filter((c) => {
    return !(categories.indexOf(c) >= 0);
  });

  const menuItems = availableCategories.map(cat => (
    <MenuItem key={`add-category-${report.id}-${cat}`} value={cat} onClick={ () => handleAdd(cat) }> {cat} </MenuItem>
  ));
  const chips = categories.filter(c => c !== 'POSSIBLY_UNSAFE').map(cat => (
    <Chip sx={ { margin: '3px' } } key={cat} label={capitalizeFirstLetter(cat)} onDelete={() => handleDelete(cat)}/>
  ));
  const label = `add-category-${report.id}`;
  const labelId = `add-category-label-${report.id}`;
  return (
    <React.Fragment>
      <FormControl fullWidth>
        <InputLabel sx={ { backgroundColor: 'white' } } id={labelId}>Add tag</InputLabel>
        <Select
          id={label}
          key={labelId}
          labelId={labelId}
          multiple
          label="Add tag"
          value={categories}
        >
          {menuItems}
        </Select>
      </FormControl>
      <FormControl sx={ { margin: '2em 0'} }>
        <Grid>{chips}</Grid>
      </FormControl>
    </React.Fragment>
  );
}
